/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TileRating = {
    ratingDescription?: TileRating.ratingDescription;
    ratingCount?: number;
    ratingsAverage?: number | null;
};
export namespace TileRating {
    export enum ratingDescription {
        AVERAGE = 'average',
        DECENT = 'decent',
        GOOD = 'good',
        VERY_GOOD = 'veryGood',
        SENSATIONAL = 'sensational',
    }
}
